<template>
  <div id="actionPlanSetUpTab">
    <el-row
      v-if="['desktop', 'laptop'].includes($mq)"
      type="flex"
      class="layout"
    >
      <el-col
        :span="12"
        class="left"
      >
        <div
          class="scroll-area customScroll"
          :settings="scrollbarSettings"
        >
          <div
            v-if="feedforwards.length > 0"
            class="feedforwards"
          >
            <el-row
              v-for="(feedforward, key) in feedforwards"
              :key="key"
              class="feedforwardLine"
              type="flex"
              :gutter="10"
            >
              <el-col
                :span="24"
                class="content"
              >
                <Drag
                  class="drag"
                  :transfer-data="{feedforward: feedforward.suggestion}"
                  :effect-allowed="['copy']"
                  drop-effect="copy"
                  :draggable="status !== 'published'"
                  @dragstart="drag = true"
                  @dragend="drag = false"
                >
                  <el-card
                    shadow="hover"
                    class="clear-card"
                    :body-style="{padding: '10px'}"
                  >
                    <div class="textDate">
                      {{ feedforward.supporter ? `${feedforward.supporter} -` : '' }}
                      {{ feedforward.created_at | moment("YYYY-MM-DD") }}
                    </div>
                    <div class="textSuggest">
                      {{ feedforward.suggestion }}
                    </div>
                  </el-card>
                </Drag>
              </el-col>
            </el-row>
          </div>

          <div
            v-else
            class="noData"
          >
            {{ $t('actionPlan.noSuggest') }}
          </div>
        </div>
      </el-col>
      <el-col
        :span="12"
        class="right"
      >
        <div
          class="scroll-area customScroll"
          :settings="scrollbarSettings"
        >
          <div class="inputAlert">
            {{ $t('actionPlan.pleaseInputMinimum') }}
          </div>
          <div class="actionPlansList">
            <transition-group
              name="el-zoom-in-top"
              enter-active-class=""
            >
              <div
                v-for="(actionPlan, key) in formattedActionPlans"
                :key="`actionKey${key}`"
                class="actionPlan"
              >
                <div class="description">
                  <Drop
                    class="drop"
                    :class="{over: over[`input${key}`], drag}"
                    @dragover="isOver = true; over[`input${key}`] = true"
                    @dragleave="isOver = false; over[`input${key}`] = false"
                    @drop="handleDropEdit(key, ...arguments)"
                  >
                    <el-input
                      v-model="actionPlan.description"
                      class="descriptionTextarea"
                      :autosize="{minRows: 2}"
                      type="textarea"
                      :rows="2"
                      :placeholder="$t('actionPlan.pleaseInput')"
                      :disabled="status === 'published'"
                      @change="updateParentActionPlan"
                    />
                  </Drop>
                </div>
                <div class="settings">
                  <el-select
                    v-model="actionPlan.settings.period"
                    :placeholder="$t('common.select')"
                    :disabled="status === 'published'"
                    @change="updateParentActionPlan"
                  >
                    <el-option
                      v-for="(period, pKey) in periods"
                      :key="pKey"
                      :label="period.label"
                      :value="period.value"
                    />
                  </el-select>

                  <!--<el-checkbox-group
                  v-show="false"
                  v-if="actionPlan.settings.period === 'daily'"
                  v-model="actionPlan.settings.days"
                  size="small"
                  :min="2"
                  disabled
                  @change="updateParentActionPlan"
                >
                  <el-checkbox-button
                    v-for="(day, index) in days"
                    :key="index"
                    :label="day.value"
                  >
                    {{ day.label }}
                  </el-checkbox-button>
                </el-checkbox-group>-->

                  <el-button
                    type="text"
                    size="medium"
                    class="clearBtn"
                    @click="clearActionPlan(key)"
                  >
                    {{ $t('common.delete') }}
                  </el-button>
                </div>
              </div>
            </transition-group>

            <div style="display: none;">
              {{ drag }} / {{ isOver }} / {{ over }}
            </div>
            <Drop
              class="drop"
              :class="{over: over.button, drag}"
              @dragover="isOver = true; over.button = true;"
              @dragleave="isOver = false; over.button = false;"
              @drop="handleDropAdd"
            >
              <el-button
                class="addActionPlanButton"
                :disabled="status === 'published'"
                @click="addActionPlan"
              >
                {{ $t('actionPlan.addOrDrop') }}
              </el-button>
            </Drop>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row
      v-else
      id="mobileLayout"
      type="flex"
      class="layout"
    >
      <el-col class="right">
        <div class="scroll-area">
          <div class="actionPlansList">
            <transition-group
              name="el-zoom-in-top"
              enter-active-class=""
            >
              <div
                v-for="(actionPlan, key) in formattedActionPlans"
                :key="`formatKey${key}`"
                class="actionPlan"
              >
                <div class="description">
                  <div class="drop">
                    <el-input
                      v-model="actionPlan.description"
                      class="descriptionTextarea"
                      :autosize="{minRows: 2}"
                      type="textarea"
                      :rows="2"
                      :placeholder="$t('actionPlan.pleaseInput')"
                      :disabled="status === 'published'"
                      @change="updateParentActionPlan"
                    />
                  </div>
                </div>
                <div class="settings">
                  <el-select
                    v-model="actionPlan.settings.period"
                    :placeholder="$t('common.select')"
                    :disabled="status === 'published'"
                    @change="updateParentActionPlan"
                  >
                    <el-option
                      v-for="(period, pKey) in periods"
                      :key="pKey"
                      :label="period.label"
                      :value="period.value"
                    />
                  </el-select>

                  <!--<el-checkbox-group
                  v-show="false"
                  v-if="actionPlan.settings.period === 'daily'"
                  v-model="actionPlan.settings.days"
                  size="small"
                  :min="2"
                  disabled
                  @change="updateParentActionPlan"
                >
                  <el-checkbox-button
                    v-for="(day, index) in days"
                    :key="index"
                    :label="day.value"
                  >
                    {{ day.label }}
                  </el-checkbox-button>
                </el-checkbox-group>-->

                  <el-button
                    type="text"
                    size="medium"
                    class="clearBtn"
                    @click="clearActionPlan(key)"
                  >
                    {{ $t('common.delete') }}
                  </el-button>
                </div>
              </div>
            </transition-group>

            <div class="drop">
              <el-button
                class="addActionPlanButton"
                @click="addActionPlan"
              >
                {{ $t('actionPlan.clickToAdd') }}
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop';

export default {
  components: {
    Drag,
    Drop,
  },

  props: {
    status: {
      type: String,
      default: '',
    },

    feedforwards: {
      type: Array,
      default: null,
    },

    actionPlans: {
      type: Array,
      default: null,
    },
  },

  data() {
    return {
      formattedActionPlans: [],
      periods: [
        {
          label: this.$t('settings.daily'),
          value: 'daily',
        },
        {
          label: this.$t('settings.weekly'),
          value: 'weekly',
        },
        {
          label: this.$t('settings.monthly'),
          value: 'monthly',
        },
      ],
      days: [
        {
          label: this.$t('settings.days.short.mon'),
          value: 'Mon',
        },
        {
          label: this.$t('settings.days.short.tue'),
          value: 'Tue',
        },
        {
          label: this.$t('settings.days.short.wed'),
          value: 'Wed',
        },
        {
          label: this.$t('settings.days.short.thu'),
          value: 'Thu',
        },
        {
          label: this.$t('settings.days.short.fri'),
          value: 'Fri',
        },
        {
          label: this.$t('settings.days.short.sat'),
          value: 'Sat',
        },
        {
          label: this.$t('settings.days.short.sun'),
          value: 'Sun',
        },
      ],
      // isOver is never read
      // for some reason @dragover="over[`input${key}`] = true" doesn't fire
      // but @dragover="isOver = true; over[`input${key}`] = true" fire. Don t ask why...
      isOver: false,
      over: {},
      drag: false,
      scrollbarSettings: {
        maxScrollbarLength: 300,
        minScrollbarLength: 50,
        scrollXMarginOffset: 10,
      },
    };
  },

  watch: {
    actionPlans: {
      handler() {
        if (this.formattedActionPlans.length < 3) {
          this.formatActionPlan();
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    formatActionPlan() {
      let ap = [];
      if (this.actionPlans) {
        ap = this.actionPlans.map((el) => {
          const data = el;
          // format data
          if (!data.settings.period) data.settings.period = 'daily';
          if (data.settings.period === 'daily' && !data.settings.days) {
            data.settings.days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
          }
          if (!data.tmpId) {
            data.tmpId = Math.random().toString(36).substring(2, 15); // create tmp ID for index
          }
          return data;
        });
      }

      // add default
      while (ap.length < 3) {
        ap.push({
          description: '',
          tmpId: Math.random().toString(36).substring(2, 15), // create tmp ID for index
          settings: {
            period: 'daily',
            days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
          },
        });
      }

      this.formattedActionPlans = ap;
    },

    updateParentActionPlan() {
      this.$emit('update:actionPlans', this.formattedActionPlans);
    },

    addActionPlan() {
      this.formattedActionPlans.push({
        description: '',
        settings: {
          period: 'daily',
          days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        },
      });
      this.$emit('update:actionPlans', this.formattedActionPlans);
    },

    clearActionPlan(num) {
      this.formattedActionPlans.splice(num, 1);
      this.$emit('update:actionPlans', this.formattedActionPlans);
    },

    handleDropAdd(data) {
      this.over.button = false;
      this.formattedActionPlans.push({
        description: data.feedforward,
        tmpId: Math.random().toString(36).substring(2, 15), // create tmp ID for index
        settings: {
          period: 'daily',
          days: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        },
      });
      this.$emit('update:actionPlans', this.formattedActionPlans);
    },

    handleDropEdit(index, data) {
      this.over[`input${index}`] = false;
      // actionPlan.description = data.feedforward;
      this.formattedActionPlans[index].description = data.feedforward;
      this.formattedActionPlans[index].tmpId = Math.random().toString(36).substring(2, 15);
      this.$emit('update:actionPlans', this.formattedActionPlans);
    },
  },
};
</script>

<style lang="scss" scoped>
  #actionPlanSetUpTab {
    text-align: left;

    .layout {
      .scroll-area {
        position: relative;
        margin: auto;
        height: 500px;
      }

      .left {
        border-right-color: #c4c4c4;
        border-right-style: solid;
        border-right-width: 1px;

        .feedforwards {
          padding: 0 20px;

          .feedforwardLine {
            margin-bottom: 20px;

            .textDate {
              font-style: italic;
              font-size: 12px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              margin-bottom: 5px;
            }
          }
        }

        .noData {
          text-align: center;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          font-style: italic;
        }
      }

      .right {
        .drop {
          border-radius: 4px;

          &.over {
            background-color: rgba(255, 255, 255, 0.15);
          }

          &.drag {
            box-shadow: 0 0 10px 2px #00000036;
          }
        }

        .inputAlert {
          padding: 0 20px 20px;
          font-size: 14px;
          font-style: italic;
          color: var(--themeFontColor);
        }

        .actionPlansList {
          padding: 0 20px;

          .actionPlan {
            margin-bottom: 30px;

            .description {
              margin-bottom: 10px;
            }

            .settings {
              display: flex;
              justify-content: space-between;

              .el-select {
                width: 150px;
              }

              .clearBtn {
                color: var(--themeFontColor);
                text-decoration: underline;
              }
            }
          }

          .addActionPlanButton {
            width: 100%;
            height: 80px;
            border-style: dashed;
            background-color: rgba(255, 255, 255, 0.15);
            color: var(--themeFontColor);
            font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
            word-break: break-word;
            white-space: normal;
          }
        }
      }
    }

    #mobileLayout {
      margin-bottom: 30px;

      .right {
        .scroll-area {
          height: 100% !important;

          .actionPlansList {
            padding: 10px 0;

            .actionPlan {
              margin-bottom: 20px;
              padding-bottom: 20px;
              border-bottom: 1px solid #c4c4c4;
            }

            .addActionPlanButton {
              height: 55px;
            }
          }
        }
      }
    }
  }
</style>

<style lang="scss">
  #actionPlanSetUpTab {
    .layout {
      .customScroll {
        scrollbar-color: #c8c8c8 transparent;
        overflow-y: scroll; /* has to be scroll, not auto */
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
          width: 5px;
        }

        &::-webkit-scrollbar-thumb {
          background: #c8c8c8;
          border-radius: 20px;
        }

        &::-webkit-scrollbar-track {
          background: transparent !important;
        }
      }

      .right {
        .description {
          .descriptionTextarea {
            .el-textarea__inner {
              font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
              background-color: transparent;
              color: var(--themeFontColor);
              resize: none;
            }
          }
        }

        .settings {
          .el-select {
            .el-input__inner {
              border-radius: 20px;
            }
          }

          .el-checkbox-button,
          .el-radio-button {
            .el-radio-button__inner,
            .el-checkbox-button__inner {
              cursor: default !important;
              padding: 8px;
              border-radius: 50%;
              width: 30px;
              height: 30px;
              margin-right: 5px;
              border-left: unset;
              border: 1px solid var(--themeFontColor);
              color: var(--themeFontColor);
              border-color: var(--themeFontColor);
              background-color: transparent;
            }

            &.is-checked,
            &.is-active {
              .el-radio-button__inner,
              .el-checkbox-button__inner {
                border-width: 0;
                border-left: unset;
                border: 1px solid #00ace2;
                background-color: #00ace2;
                box-shadow: none;
              }
            }
          }
        }
      }
    }

    #mobileLayout {
      .right {
        .descriptionTextarea {
          .el-textarea__inner {
            border: none;
            border-radius: 5px;
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }
    }
  }
</style>
